import dynamicLocalization from "@/mixins/dynamic-localization";

export default {
  mixins: [dynamicLocalization],
  props: {
    segment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formats() {
      let formattingOptions = this.segment.format;

      if (typeof this.segment.format === "string") {
        formattingOptions = [this.segment.format];
      }

      return formattingOptions || [];
    },
    textData() {
      if (this.segment.text) {
        return this.segment.text;
      }

      return this.segment;
    },
    textLocalized() {
      return this.$dt(this.textData);
    },
    needsWhitespaceBefore() {
      if (!this.textLocalized) {
        return false;
      }

      const whitespaceTokens = ".,:";
      return whitespaceTokens.indexOf(this.textLocalized[0]) === -1;
    },
  },
};
